/**
 * @returns a localized a price
 * @param locale Locale to use for formatting
 * @param value Price to localize
 * @param currency The currency attached to the price
 * @param decimalPlaces Number of decimals to keep

 */
export function formatPrice(
  locale: string,
  value: unknown,
  currency: string | undefined,
  decimalPlaces = 2
) {
  if (typeof value !== 'number') return value;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: decimalPlaces,
  }).format(value);
}
